import { Col, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiService, Request } from "../../api";
import DynamicFilterForm, {
  FilterValues,
} from "../../components/DynamicFilterForm";
import { exportRequestsToExcel } from "../../utils/exportRequests";
import { usePagination } from "../../hooks/usePagination";
import ManageableTable, {
  ManageableColumn,
} from "../../components/ManageableTable";

export const ListPage = () => {
  const { t } = useTranslation();
  const columns: ManageableColumn<Request>[] = [
    {
      key: "id",
      title: t("ID"),
      dataIndex: "id",
      width: 80,
    },
    {
      key: "number",
      title: t("Number"),
      dataIndex: "number",
      width: 160,
    },
    {
      key: "template",
      title: t("Template"),
      width: 140,
      render: (_, record) => (
        <Space size="middle">{record.template?.short_name}</Space>
      ),
    },
    {
      key: "description",
      title: t("Description"),
      dataIndex: "description",
      width: 300,
    },
    {
      key: "actions",
      title: t("Actions"),
      width: 100,
      hideable: false,
      render: (_, record) => (
        <Space size="middle">
          <a href={`/requests/${record.id}`}>{t("View")}</a>
        </Space>
      ),
    },
  ];
  const [data, setData] = useState<Array<Request>>([]);
  const [loading, setLoading] = useState(false);
  const [filterValues, setFilterValues] = useState<FilterValues>({});
  const { page, pageSize, applyResponse, resetPage, paginationProps } =
    usePagination();

  useEffect(() => {
    setLoading(true);
    ApiService.apiMainRequestsList({
      ...filterValues,
      page,
      page_size: pageSize,
    })
      .then((result) => {
        setData(applyResponse<Request>(result as any));
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues, page, pageSize]);

  return (
    <div>
      <Row align="middle" justify="space-between">
        <Col>
          <h2>{t("Requests")}</h2>
        </Col>
      </Row>
      <DynamicFilterForm
        onFilter={(values) => {
          setFilterValues(values);
          resetPage();
        }}
        onExport={() =>
          exportRequestsToExcel(
            { scope: "all", filter: filterValues },
            "requests.xlsx"
          )
        }
        showStatus={false}
      />
      <ManageableTable
        tableId="requests-all"
        dataSource={data}
        columns={columns}
        loading={loading}
        pagination={paginationProps}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default ListPage;
